import { ImageWMS } from 'ol/source';
import {Group, Image as ImageLayer} from 'ol/layer';

const urlEstadistica=import.meta.env.VITE_GEOSERVER_URL;

//layers limites
const layers2010=[
    {title:'Fracciones 2010',layer:'fracciones_censo_2010'},
    {title:'Radios 2010',layer:'radios_censo_2010'},
    {title:'Departamentos 2010',layer:'departamentos_2010'},
    {title:'Gobiernos locales 2010',layer:'gobiernos_locales_2010'}
]

const imageLayers2010=layers2010.map(({title,layer})=> new ImageLayer({
    title,
    visible:false,
    source: new ImageWMS({
        url: `${urlEstadistica}/limites/wms`,
        params: { 'LAYERS': layer,grupo:'limites'},
        serverType: 'geoserver',
        crossOrigin:'Anonymous'
    })
}))

//layers limites
const layers2022=[
    {title:'Fracciones 2022',layer:'fracciones_censo_2022'},
    {title:'Radios 2022',layer:'radios_censo_2022'},
    {title:'Departamentos 2022', layer:'departamentos_2022'},
    {title:'Gobiernos locales 2022', layer:'gobiernos_locales_2022'}
]

const imageLayers2022=layers2022.map(({title,layer})=> new ImageLayer({
    title,
    visible:false,
    source: new ImageWMS({
        url: `${urlEstadistica}/limites/wms`,
        params: { 'LAYERS': layer,grupo:'limites'},
        serverType: 'geoserver',
        crossOrigin:'Anonymous'
    })
}))


export const marcoGeoestadistico=new Group({
    title: 'Marco Geoestadístico',
    fold:'close',
    layers:[
    new Group({
        title:'2022',
        fold:'close',
        layers:imageLayers2022
        }),
    new Group({
        title:'2010',
        fold:'close',
        layers:imageLayers2010
        }),    
    ]    
})